module.exports = __webpack_public_path__ + "static/media/pro-detail-img4.9b93ff60.jpg";